import { type ReactNode } from 'react';
import { BODY, Bullet, PullQuote, Section } from './rules-typography';

export function YourProgress(): ReactNode {
  return (
    <Section title="9. Tu progreso">
      <ul className={`${BODY} space-y-1.5`}>
        <Bullet>
          Ves cuánto generas desde la web y desde el DM de Instagram.
        </Bullet>
        <Bullet>Cada día empieza desde cero.</Bullet>
        <Bullet>Todo suma al ranking semanal.</Bullet>
      </ul>
    </Section>
  );
}

export function GameSummary(): ReactNode {
  return (
    <Section title="Resumen del juego">
      <ul className={`${BODY} space-y-1.5`}>
        <Bullet>Creas tu cuenta de jugador.</Bullet>
        <Bullet>Entrenas el algoritmo.</Bullet>
        <Bullet>Encuentras perfiles.</Bullet>
        <Bullet>Loop infinito.</Bullet>
        <Bullet>Envías links.</Bullet>
        <Bullet>Completas datos.</Bullet>
        <Bullet>Evitas strikes.</Bullet>
        <Bullet>Subes en el ranking.</Bullet>
        <Bullet>Cobras cada lunes.</Bullet>
      </ul>
    </Section>
  );
}

export function FinalKey(): ReactNode {
  return (
    <Section title="La última clave">
      <p className={BODY}>
        Esto no va de pensar. Va de llegar antes y entrar en flow.
      </p>
      <PullQuote>
        Encuentra → envía → repite. Encuentra → envía → repite. Encuentra →
        envía → repite.
      </PullQuote>
    </Section>
  );
}
